import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {User} from 'classes/user';
import {UserRole} from 'classes/user-role';
import {environment} from 'environment';
import { TargetGroup } from 'shared/models/target-groups/target-group';

@Injectable()
export class UserListRepository {

  constructor(private http: Http) { }

  public getUsers(): Observable<Array<User>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(environment.users, options)
      .map((res: Response) => {
        return res.json();
      })
      .map((rawUsers: Array<User>) => {
        return this.mapUsers(rawUsers);
      });
  }

  public deleteUser(id: number): Observable<Response> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.delete(`${environment.users}/${id}`, options);
  }

  private mapUsers(rawUsers: Array<User>): Array<User> {
    return rawUsers.map((rawUser) => {
      return User.create(rawUser);
    });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-list/repositories/user-list.repository.ts